type Translator = (key: string) => string;

export function localizeError(err: unknown, t: Translator, fallbackKey?: string): string {
  const message = err instanceof Error ? err.message : String(err);

  const tWithFallback = (key: string, literal: string): string => {
    const translated = t(key);
    return translated === key ? literal : translated;
  };

  const roleMatch = message.match(/Required role not present:\s*([A-Z_]+)/i);
  if (roleMatch) {
    const role = roleMatch[1];
    const specific = t(`errors.requiredRole.${role}`);
    if (specific !== `errors.requiredRole.${role}`) return specific;
    return tWithFallback('errors.requiredRole', 'You do not have permission to access this section.');
  }

  if (message === 'Authentication required') {
    return tWithFallback('errors.authenticationRequired', 'Please sign in to continue.');
  }

  return fallbackKey ? tWithFallback(fallbackKey, message) : message;
}

/**
 * Ticket #996: the garages service answers 409 with `error` and `code` both set to
 * CONCURRENT_UPDATE when a save lost an optimistic-lock race (someone else — e.g. an admin
 * approving a variant — changed the same service first). Duck-typed so it works on any
 * ApiError-shaped value without importing the api module.
 */
export const CONCURRENT_UPDATE = 'CONCURRENT_UPDATE';

export const CONCURRENT_UPDATE_MESSAGE = 'This was changed elsewhere — reload to see the latest.';

export function isConcurrentUpdateError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const e = err as { status?: unknown; code?: unknown; errorCode?: unknown };
  return e.status === 409 && (e.code === CONCURRENT_UPDATE || e.errorCode === CONCURRENT_UPDATE);
}
